import React from "react";
import { EditIcon } from "../editIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function Section({ title, children, edit }: Props) {
  return (
    <div className={styles.section}>
      <div className={styles.heading}>
        <h1 className={styles.title}>{title}</h1>
        {edit && (
          <div className={styles.iconBox} onClick={edit}>
            <EditIcon className={styles.icon} />
          </div>
        )}
      </div>
      <div className={styles.main}>{children}</div>
    </div>
  );
}

export { Section };
